<template>
  <div class="page-project-index">
    <skeleton v-if="loading" />
    <template v-else>
      <header-block :banner="banner"
                    :search="render.search"
                    @click-banner="handleClickBanner"
      />
      <product-list class="project-main-block-container"
                    :main-block="mainBlock"
                    empty-string="暂无项目"
      />
    </template>
  </div>
</template>

<script>
  import Skeleton from '@/skeleton/ProjectIndex';
  import { getProjectHome } from '@/services/project';
  import HeaderBlock from '@/components/HomeHeaderBlock';
  import ProductList from '@/components/Product/BlockList';

  export default {
    name: 'PageProject',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      Skeleton,
      HeaderBlock,
      ProductList,
    },
    data() {
      return {
        loading: false,
        banner: [],
        mainBlock: [],
        render: {
          pageTitle: '线下项目',
          search: null,
        },
      };
    },
    methods: {
      async fetchData() {
        this.loading = true;

        const data = await getProjectHome();
        this.banner = data.banner;
        this.mainBlock = data.mainBlock;
        this.render = data.render;

        this.loading = false;
      },
      handleClickBanner(item) {
        this.$router.push(item.url);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
</style>
